// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__3PA2G","resendInfoText":"OnGoingPaymentBox_resendInfoText__25vEJ"};